import {translation} from "@2d-front-monorepo/core";
import {
	IMvvmContextState,
	MvvmTextInput,
	ValidationRequirementEntry,
	ValidationRequirements
} from "@2d-front-monorepo/design-library";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX, useCallback, useState} from "react";
import usePasswordRequiredPolicy from "../policies/passwordRequiredPolicy";
import usePasswordRules, {PASSWORD_MIN_LENGTH} from "../policies/passwordRules";

type Model = {
	password: string;
}

type UserPasswordProps = {
	context: IMvvmContextState<Model>
};

export default function UserPassword(props: UserPasswordProps): JSX.Element {
	const {context} = props;
	const rules = usePasswordRules();

	const [checkedItems, setCheckedItems] = useState<ValidationRequirementEntry[]>(
		() => rules.map(rule => ({text: rule.text, checked: false}))
	);

	const onPasswordChange = useCallback(function () {
		requestAnimationFrame(async () => {
			await context.validationEnds();
			const password = context.getValue<string>("password") ?? "";
			setCheckedItems(rules.map(rule => ({text: rule.text, checked: rule.test(password)})));
		});

	}, [context, rules]);

	return <>
		<MvvmTextInput type="password"
		               context={context}
		               property="password"
		               autoComplete="new-password webauthn"
		               label={translation(PermitTranslations.sign_up_page__mandatory_password)}
		               validation={usePasswordRequiredPolicy(true)}
		               validateOnChange={true}
		               minLength={PASSWORD_MIN_LENGTH}
		               onChange={onPasswordChange}/>

		<ValidationRequirements title={translation(PermitTranslations.validation__password_rules)}
		                        entries={checkedItems}/>
	</>;
};
